import Vue from 'vue'
import Router from 'vue-router'

// 导入其他模块的路由
import Home from '@district/views/Home.vue'
import SubHome from '@district/views/home/Home.vue'
import Stadium from '@district/views/stadium/Home.vue'
import Project from '@district/views/project/Home.vue'
import Schedule from '@district/views/schedule/Home.vue'
import Delegation from '@district/views/delegation/Home.vue'
import DelegationHome from '@district/views/delegation/components/DelegationHome.vue'
import DelegationSignup from '@district/views/delegation/components/DelegationSignup.vue'
import DelegationDetail from '@district/views/delegation/components/DelegationDetail.vue'
import DelegationPlayer from '@district/views/delegation/components/DelegationPlayer.vue'
import Beautiful from '@district/views/beautiful/Home.vue'
import MatchDetail from  '../views/project/components/Detail.vue'
import MatchGame from  '../views/project/components/Game.vue'
import MatchAgency from  '../views/project/components/Agency.vue'
import MatchRank from  '../views/project/components/Rank.vue'
import MatchNotice from  '../views/project/components/Notice.vue'
import BasketallTeam from  '../views/project/components/BasketallTeam.vue'
import Join from  '../views/project/components/Join.vue'
import TrackField from  '@district/views/project/components/TrackField.vue'
import VolleyBall from  '@district/views/project/components/VolleyBall.vue'
import BasketBall from  '@district/views/project/components/BasketBall.vue'
import TrackFieldPlayer from  '@district/views/project/components/TrackFieldPlayer.vue'
import BasketallPlayer from  '@district/views/project/components/BasketallPlayer.vue'
import Center from  '@district/views/icenter/Home.vue'
import CenterAgency from '@district/views/icenter/Agency.vue'
Vue.use(Router)
/**
 * Uncaught (in promise) NavigationDuplicated: Avoided redundant navigation to current location报错
 * 添加以下代码
 */
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'Home',
      redirect: '/',
      component: Home,
      meta: {
        title: '首页',
        menuIndex:0
      },
      children: [
        {
          path: '/',
          name: 'SubHome',
          component: SubHome,
          meta: {
            title: '首页',
            menuIndex:0
          }
        },
        {
          path: '/project',
          name: 'Project',
          component: Project,
          meta: {
            title: '竞赛项目',
            menuIndex:1
          },
        },
        {
          path: '/schedule',
          name: 'Schedule',
          component: Schedule,
          meta: {
            title: '赛程赛果',
            menuIndex:2
          }
        },
        {
          path: '/delegation/signup',
          name: 'DelegationSignup',
          component: DelegationSignup,
          meta: {
            title: '代表团报名',
            menuIndex:3
          }
        },
        {
          path: '/delegation',
          name:'Delegation',
          component:Delegation,
          meta: {
            title: '代表团',
            menuIndex:3
          },
          children: [
            {
              path: '/',
              name: 'DelegationHome',
              component: DelegationHome,
              meta: {
                title: '代表团首页',
                menuIndex:3
              },
            },
            {
              path: 'detail',
              name: 'DelegationDetail',
              component: DelegationDetail,
              meta: {
                title: '代表团详情',
                menuIndex:3
              },
            },
            {
              path: 'player',
              name: 'DelegationPlayer',
              component: DelegationPlayer,
              meta: {
                title: '运动员详情',
                menuIndex:3
              },
            },
          ]
        },
        {
          path: '/stadium',
          name: 'Stadium',
          component: Stadium,
          meta: {
            title: '场馆指南',
            menuIndex:4
          }
        },
        {
          path: '/beautiful',
          name: 'Beautiful',
          component: Beautiful,
          meta: {
            title: '最美九龙坡',
            menuIndex:5
          },
          children: [
            {
              path: '/beautifulJiulong',
              name: 'BeautifulJiulong',
              meta: {
                title: '最美九龙坡'
              },
              component: () => import('@district/views/beautiful/components/BeautifulJiulong.vue')
            },
            {
              path: '/wonderfulMoments',
              name: 'WonderfulMoments',
              meta: {
                title: '精彩瞬间'
              },
              component: () => import('@district/views/beautiful/components/WonderfulMoments.vue')
            }
          ]
        },
      ]
    },
    {
      path: '/MatchDetail',
      name: 'MatchDetail',
      component: MatchDetail,
      meta: {
        title: ''
      }
    },
    {
      path: '/MatchAgency',
      name: 'MatchAgency',
      component: MatchAgency,
      meta: {
        title: '参赛数据 '
      }
    },
    {
      path: '/MatchGame',
      name: 'MatchGame',
      component: MatchGame,
      meta: {
        title: '场次对战 '
      }
    }, {
      path: '/MatchRank',
      name: 'MatchRank',
      component: MatchRank,
      meta: {
        title: '奖牌榜 '
      }
    },   {
      path: '/Join',
      name: 'Join',
      component: Join,
      meta: {
        title: '赛事报名 '
      }
    },
    {
      path: '/MatchNotice',
      name: 'MatchNotice',
      component: MatchNotice,
      meta: {
        title: '赛事公告 '
      }
    },
    {
      path: '/trackfield',
      name: 'TrackField',
      component: TrackField,
      meta: {
        title: '田径赛事 '
      }
    },
    {
      path: '/volleyball',
      name: 'VolleyBall',
      component: VolleyBall,
      meta: {
        title: '排球赛事'
      }
    },
    {
      path: '/basketball',
      name: 'BasketBall',
      component: BasketBall,
      meta: {
        title: '篮球赛事'
      }
    },
    {
      path: '/TrackFieldPlayer',
      name: 'TrackFieldPlayer',
      component: TrackFieldPlayer,
      meta: {
        title: '运动员详情',
      }
    },
    {
      path: '/BasketallPlayer',
      name: 'BasketallPlayer',
      component: BasketallPlayer,
      meta: {
        title: '运动员详情',
      }
    },
    {
      path: '/Center',
      name: 'Center',
      component: Center,
      meta: {
        title: '个人中心',
        breadcrumb: [{
          url: '/Center',
          name: '个人中心 '
        }],
      },
      
    },
    {
      path: '/CenterAgency',
      name: 'CenterAgency',
      component: CenterAgency,
      meta: {
        title: '机构管理 ',
        breadcrumb: [{
          url: '/Center',
          name: '个人中心 '
        }, {
          url: '/CenterAgency',
          name: '机构管理'
        }]
      }
    },
    {
      path: '/BasketallTeam',
      name: 'BasketallTeam',
      component: BasketallTeam,
      meta: {
        title: '篮球队伍详情',
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/district/router/index.js